import { ReactNode } from 'react';
import { Settings } from 'src/@core/context/settingsContext';
import Direction from 'src/layouts/components/Direction';

interface Props {
  settings: Settings;
  children: ReactNode;
}

const ThemeComponent = ({ settings, children }: Props) => {
  return (
    <Direction direction={settings.direction}>{children}</Direction>
  );
};

export default ThemeComponent;
